import mapboxgl from 'mapbox-gl';

export const MapPopup = (coordinates, properties) => {
  const defaultImage = '/depot.jpg';
  const isMobile = window.innerWidth <= 768;
  
  // Vérifier si les propriétés existent et sont des objets
  const depot_info = typeof properties.depot_info === 'string' 
    ? JSON.parse(properties.depot_info || '{}') 
    : (properties.depot_info || {});
    
  const proprietaire = typeof properties.proprietaire === 'string' 
    ? JSON.parse(properties.proprietaire || '{}') 
    : (properties.proprietaire || {});
    
  const gerant = typeof properties.gerant === 'string' 
    ? JSON.parse(properties.gerant || '{}') 
    : (properties.gerant || {});
    
  const infrastructure = typeof properties.infrastructure === 'string' 
    ? JSON.parse(properties.infrastructure || '{}') 
    : (properties.infrastructure || {});

  const popup = new mapboxgl.Popup({
    closeButton: false,
    closeOnClick: false,
    maxWidth: isMobile ? '90vw' : '400px',
    className: `custom-popup ${isMobile ? 'mobile-popup' : ''}`,
    anchor: isMobile ? 'bottom' : 'bottom',
    offset: isMobile ? [0, -15] : [0, -35]
  });

  const popupContent = `
    <div class="${isMobile ? 'w-[90vw] max-w-[300px]' : 'w-[320px]'} bg-white rounded-xl overflow-hidden">
      <div class="p-3">
        <div class="flex justify-between items-start">
          <button 
            class="text-gray-400 hover:text-gray-600 flex-shrink-0 ml-auto"
            onclick="this.closest('.mapboxgl-popup').remove()"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div class="${isMobile ? 'flex flex-col' : 'flex gap-3'}">
          <div class="${isMobile ? 'w-full h-32 mb-3' : 'w-28 h-24'} flex-shrink-0">
            <img 
              src="${properties.devanture_url || defaultImage}" 
              alt="Devanture du dépôt" 
              class="w-full h-full object-cover rounded-lg shadow-sm"
              onerror="this.src='${defaultImage}'"
            />
          </div>
          
          <div class="flex-1">
            <div class="mb-3">
              <h3 class="text-sm font-semibold text-gray-900 mb-1">${properties.title || ''}</h3>
              <p class="text-xs text-gray-500">${properties.adresse || ''}</p>
              <p class="text-xs text-gray-500">${properties.commune || ''} ${properties.region ? `, ${properties.region}` : ''}</p>
            </div>

            <div class="border-t border-gray-100 pt-2">
              <div class="grid grid-cols-1 gap-y-1 text-xs text-gray-600">
                <p><span class="font-medium">Propriétaire:</span> ${proprietaire.nom || ''}</p>
                <p><span class="font-medium">Tél. Propriétaire:</span> ${proprietaire.telephone || ''}</p>
                <p><span class="font-medium">Gérant:</span> ${gerant.nom || ''}</p>
                <p><span class="font-medium">Tél. Gérant:</span> ${gerant.telephone || ''}</p>
                <p><span class="font-medium">Localité:</span> ${properties.localite || ''}</p>
                <p><span class="font-medium">Quartier:</span> ${properties.quartier || ''}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="flex mt-3 pt-3 border-t border-gray-100">
          <button 
            onclick="if(window.initializeRoute) window.initializeRoute(${JSON.stringify(coordinates)}); else console.error('initializeRoute not defined');"
            class="w-full inline-flex items-center justify-center px-3 py-2 text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 transition-colors"
          >
            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
            </svg>
            Itinéraire
          </button>
        </div>
      </div>
    </div>
  `;

  return popup
    .setLngLat(coordinates)
    .setHTML(popupContent);
};